export default (importData) => ({
    progress: importData.progress,
    status: importData.status,
    imported_episodes: importData.imported_episodes,
    podcast_id: importData.podcast_id,
    errors: importData.errors,
    init() {
        window.Echo.private(`Account.${importData.account_id}`)
            .listen('Importer.ImportProgressUpdated', (e) => {
                if (e.id === importData.id) { 
                this.progress = e.progress
                this.status = e.status
                this.imported_episodes = e.imported_episodes
                this.podcast_id = e.podcast_id
                this.errors = e.errors
            }
        });
    }
  });